import { render, staticRenderFns } from "./essay.vue?vue&type=template&id=25448d23&scoped=true&"
import script from "./essay.vue?vue&type=script&lang=js&"
export * from "./essay.vue?vue&type=script&lang=js&"
import style0 from "./essay.vue?vue&type=style&index=0&id=25448d23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25448d23",
  null
  
)

export default component.exports